import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";

const ProtectedRoute = ({ children, allowedRole }) => {
  const { user, role, loading } = useContext(AuthContext);

  if (loading) return <p></p>; // ✅ Prevent early redirect

  if (!user) return <Navigate to="/login" />;
  if (allowedRole && role !== allowedRole) return <Navigate to="/login" />;

  return children;
};

export default ProtectedRoute;
